import { render, staticRenderFns } from "./academic_examination_fengtalk.vue?vue&type=template&id=2665d52e&"
import script from "./academic_examination_fengtalk.vue?vue&type=script&lang=js&"
export * from "./academic_examination_fengtalk.vue?vue&type=script&lang=js&"
import style0 from "./academic_examination_fengtalk.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports